import ReactDOM from 'react-dom/client';
import React from 'react';
import { InventoryDashboard } from './inventory-dashboard';
import { TenantContext } from '../../context/tenant-context';
import { InventoryGantt } from './inventory-gantt/inventory-gantt';
import { DateTime, Duration } from 'luxon';
import { v2Component } from '../../index';

export function initInventoryDashboard() {
  document.getElementsByName('inventory-dashboard').forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);
      const { tenant, contextPath, ...props } = Object.assign({}, element.dataset) as any;
      root.render(
        v2Component(
          <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
            <InventoryDashboard {...props} />
          </TenantContext.Provider>,
        ),
      );

      const event = new CustomEvent('change');
      element.dispatchEvent(event);
    }
  });

  document.getElementsByName('inventory-gantt').forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);
      const { tenant, contextPath, locationIds, productIds, expandAll, startDateTime, duration, ...props } =
        Object.assign({}, element.dataset) as any;
      root.render(
        v2Component(
          <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
            <InventoryGantt
              locationIds={JSON.parse(locationIds)}
              productIds={JSON.parse(productIds)}
              expandAll={expandAll === 'true'}
              startDateTime={startDateTime ? DateTime.fromISO(startDateTime, { setZone: true }) : undefined}
              duration={duration ? Duration.fromISO(duration) : undefined}
              {...props}
            />
          </TenantContext.Provider>,
        ),
      );

      const event = new CustomEvent('change');
      element.dispatchEvent(event);
    }
  });
}
